module Meevo.Plugins.Product {

    export enum ProductInfoModalParent {
        Convobar,
        InventoryCount,
        InventoryReturns,
        InventoryTransfer,
        Product,
        PurchaseOrder,
        Register,
        EmployeeSupplyUsage
    }

    export interface ProductInfoModalOptions {
        productId?: any;
        variantId?: any;
        productInventoryTypeEnum?: Meevo.Model.ProductInventoryTypeEnum;
        parentType: ProductInfoModalParent
        variantIdInitiator?: any; // indicates variant that triggered modal for visual indicatation in instances like Register which all variants in a product are displayed (variantId is populated when only one ever shows in product info modal)
        productVariant?: any;
        isInventoryFloorLocationModuleAvailable?: any;
    }

    export interface ProductInventoryTypeModalOptions {
        product?: any;
        labelText: string;
        noteText?: string;
        listOfTypes: Meevo.Model.ProductInventoryTypeEnum[];
    }

    export interface BarcodeImportReconcilerModalOptions {
        variants?: any;
        uniqueCodes?: any;
    }
    export interface MarketPricingModalOptions {
        id:any,
        title: string
        variantId?: any;
        productInventoryTypeEnum?: Meevo.Model.ProductInventoryTypeEnum;
        parentType?: ProductInfoModalParent
        variantIdInitiator?: any; // indicates variant that triggered modal for visual indicatation in instances like Register which all variants in a product are displayed (variantId is populated when only one ever shows in product info modal)
        productVariant?: any;
        isInventoryFloorLocationModuleAvailable?: any;
    }
    export interface IBarcodeScannerOptions {
        productInventoryTypeEnum: Meevo.Model.ProductInventoryTypeEnum;
        savedInventoryTypeEnum: Meevo.Model.ProductInventoryTypeEnum;
    }

    export interface IBarCodeScannerCallbacks {
        onScan(codes: string[]): void;
        onInventoryTypeChange(newType: Meevo.Model.ProductInventoryTypeEnum): void;
        onBarcodeScanModeChange(scanMode: Meevo.Components.Controls.BarcodeScanModes): void;
        onDestroy(isModal: boolean): void;
    };

    export interface VariantAdjustUsagePricingOptions {
        product: Meevo.Model.ProductUsage;
        variant: Meevo.Model.VariantUsageSetting;
    }
}
